import axios from 'axios';
import jwtDecode from 'jwt-decode';
import parseDomain from 'parse-domain';

const TOKEN_KEY = 'id_token';
const TOKEN_EXPIRY_KEY = 'id_token_expiry';
const USERROLE_KEY = 'id_userRole';
const ORIGINAL_ADMIN_ROLE_KEY = 'id_original_adminRole';
const TOKENEXPIRYMS = 650000;// 10 minutes.

// Roles come from Quicklinks
const qlBaseURL = process.env.QUICK_LINKS_API_URL;
const qlRoleBaseUrl = `${qlBaseURL}/v1/auth/role`;
// FYI, using Javascript proxy so returns 0 if property not in roleMap
const defaultZeroHandler = {
    get(obj, prop) {
        return prop in obj ?
            obj[prop] :
            0;
    }
};
const roleMap = new Proxy({
    'CompliSpace Administrator': 4,
    'Group Administrator': 3,
    'Client Administrator': 2,
    'Client User': 1
}, defaultZeroHandler);

export default {
    tokenExpiryMS() {
        return TOKENEXPIRYMS;
    },

    isLoggedIn() {
        // FIXME: Vote to instantiate sessionManager as a singleton
        // prior to instanting Vue.  This would eliminate this...
        //
        // This can't be async using our current startup sequence is
        // 1. Vue instantiation
        // 2. router instantiation, beforeEach and nextTick function
        // 3. App.vue instantiation, beforeCreate dispatches session/Initialise
        // An await will yield to the router beforeEach, will always
        // see user as not logged in
        const token = localStorage.getItem(TOKEN_KEY);
        const role = localStorage.getItem(USERROLE_KEY);

        if (!!token && !!role) {
            const checkIfAuthorizationTokenValid = (token) => {
                let tokenValid = false;

                if (token) {
                    const decodedToken = jwtDecode(token);
                    tokenValid = (decodedToken.exp * 1000)
                        - new Date().getTime() > this.tokenExpiryMS();
                }

                // if (!tokenValid) clear();
                return tokenValid;
            };
            return checkIfAuthorizationTokenValid(token);
        }
        return false;
    },

    getUserRoleFromLocalStorage() {
        return localStorage.getItem(USERROLE_KEY);
    },

    getOriginalAdminRoleFromLocalStorage() {
        return localStorage.getItem(ORIGINAL_ADMIN_ROLE_KEY);
    },

    getTokenFromLocalStorage() {
        return localStorage.getItem(TOKEN_KEY);
    },

    getTokenExpiryFromLocalStorage() {
        return localStorage.getItem(TOKEN_EXPIRY_KEY);
    },

    getTokenFromUri(uri) {
        return uri.match(/#(?:access_token)=([\S\s]*?)&/)[1];
    },

    saveToken(uri) {
        const token = this.getTokenFromUri(uri);
        localStorage.setItem(TOKEN_KEY, token);
        const decodedToken = jwtDecode(token);
        localStorage.setItem(TOKEN_EXPIRY_KEY, decodedToken.exp * 1000);
    },

    saveUserRole(userRole) {
        localStorage.setItem(USERROLE_KEY, userRole);
    },

    saveOriginalAdminRole(adminRole) {
        localStorage.setItem(ORIGINAL_ADMIN_ROLE_KEY, adminRole);
    },

    isTokenExpired() {
        if (!this.isLoggedIn()) {
            throw new Error('Not logged in.');
        }
    },

    getIdpRedirectUrl() {
        return `${window.location.origin}/login`;
    },

    getSubdomain() {
        const domains = parseDomain(window.location.hostname, { customTlds: ['localhost'] });
        const subdomains = domains.subdomain.split('.');

        return subdomains[0];
    },

    getXSiteUri() {
        return window.location.hostname;
    },

    getXSiteUrl() {
        return `https://${this.getXSiteUri()}`;
    },

    getFQDN() {
        return window.location.hostname;
    },

    async getIdpUri(xSiteUri) {
        const idpAxios = axios.create({
            transformRequest: [(data, headers) => {
                /* eslint-disable no-param-reassign */
                delete headers.common['x-site-uri'];
                /* eslint-enable no-param-reassign */
                return data;
            }]
        });
        const url = `https://idp.complispace.me/api/discovery?q=${encodeURIComponent(xSiteUri)}`;
        try {
            const response = await idpAxios.get(url);
            return response.data.results[0].fqdn;
        } catch (err) {
            window.location.href = process.env.IDP_ERROR_REDIRECT_URI;
            throw new Error(`No matching idp for ${xSiteUri}`);
        }
    },

    async getUserRole(idpUri) {
        if (!localStorage.getItem(TOKEN_KEY) || !idpUri) {
            throw new Error('Not logged in.');
        }

        let response;
        try {
            response = await axios.get(`${qlRoleBaseUrl}?organisation=${this.getSubdomain()}`);
        } catch (e) {
            console.log(e);
            throw new Error('Invalid user role returned. Check user rights.');
        }
        return roleMap[response.data];
    },

    async init() {
        const idpUri = await this.getIdpUri(this.getXSiteUri());

        return { idpUri };
    },

    setAuthorizationHeader(uri) {
        const token = this.getTokenFromUri(uri);
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    },

    setAuthorizationHeaderUsingLocalStorage() {
        const token = this.getTokenFromLocalStorage();
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    },

    setAdditionalHeaders() {
        axios.defaults.headers.common['x-site-uri'] = `${this.getXSiteUrl()}`;
    },

    deleteAdditionalHeaders() {
        delete axios.defaults.headers.common['x-site-uri'];
    },

    clear() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(TOKEN_EXPIRY_KEY);
        localStorage.removeItem(USERROLE_KEY);
        localStorage.removeItem(ORIGINAL_ADMIN_ROLE_KEY);
        this.clearHeaders();
    },

    clearHeaders() {
        this.deleteAdditionalHeaders();
        delete axios.defaults.headers.common.Authorization;
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/session/sessionManager.js